import '../src/assets/css/themas.css';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { 
    closeBrowserTab, 
    FingerPrintIsAvailable, 
    platform, 
    registerOnMessage, 
    getPlatformName
} from 'platformImpl';

import configuration from './envConfig';
import { atualizarSituacaoVersao, confirmarLogin, deslogarUsuario, setLoadingToken } from './login/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { decodificarToken, estaLogado, tokenDentroDaValidade } from './login/helper';
import { onDeviceReady } from './shared/helper/events';
import { showForegroundNotification } from './shared/helper/foregroundNotification';
import { Switch } from "react-router-dom";
import { verificarParametrosFirebase } from './painel/actions';
import CarteiraDigital from './apps/carteira/CarteiraDigital';
import DrawerPDF from './shared/template/drawerPDF/DrawerPDF';
import history from './history';
import Login from './login/Login';
import packageJson from "../package.json";
import ProtectedAppWrapper from './painel/ProtectedAppWrapper';
import React from 'react';
import Redirect from "CustomRedirect";
import Route from './CustomRoute';
import SolicitarAtualizacao from './SolicitarAtualizacao'
import { getSeguroPromise } from './shared/helper/requests'
import SwipableOnboardScreen from 'onBoardScreen/SwipableOnboardScreen';

window.recaptchaOptions = {
    useRecaptchaNet: true
};

window.miVersion = packageJson.version;
window.miPlatform = getPlatformName();

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reloadWindow: false,
            loadingToken: false
        }
        this.listenerStorage = this.listenerStorage.bind(this);
    }

    componentWillMount() {
        localStorage.setItem('ifs_platform', platform.name);

        localStorage.removeItem('sag-service');

        if (!platform.isCordova) {
            this.props.verificarParametrosFirebase();
        } else {
            document.addEventListener("deviceready", () => {
                if (navigator && navigator.splashscreen) {
                    navigator.splashscreen.hide();
                }
                this.props.verificarParametrosFirebase();
            }, false);
        }

        // Desloga o usuário se o token estiver vencido.
        let token = localStorage.getItem('ifs_auth');
        if (token && !tokenDentroDaValidade(token)) {
            this.props.deslogarUsuario();
        }

        //biometria recorrente
        if (platform.isCordova) {
            document.addEventListener("deviceready", () => {
                let data = decodificarToken(localStorage.getItem('ifs_auth'));
                if (data && data.sub) {
                    let keyBiometrica = `ifs_biometria_${data.sub}`
                    let ifs_biometria = localStorage.getItem(keyBiometrica) || undefined;
                    if (estaLogado()) {
                        if (sessionStorage.getItem('ignorarValidacaoBiometrica') !== 'true') {
                            if (ifs_biometria === 'true') {
                                try {
                                    FingerPrintIsAvailable(() => {
                                        history.push('/aberto/login-biometrico');
                                    }, error => {
                                        console.error(JSON.stringify(error))
                                    });
                                } catch (error) {
                                    sessionStorage.setItem('ignorarValidacaoBiometrica', 'true');
                                    this.props.deslogarUsuario();
                                    console.error(JSON.stringify(error));
                                }
                            } else {
                                sessionStorage.setItem('ignorarValidacaoBiometrica', 'true');
                                this.props.deslogarUsuario();
                            }
                        }
                    } else {
                        sessionStorage.setItem('ignorarValidacaoBiometrica', 'true');
                    }
                } else {
                    sessionStorage.setItem('ignorarValidacaoBiometrica', 'true');
                }
            }, false);
        }

        // Solicita MiToken.
        if (estaLogado()) {
            this.props.confirmarLogin();
        }
    }

    componentDidUpdate() {

        if (this.state.reloadWindow) {
            this.setState({ ...this.state, reloadWindow: false });
            window.location.reload();
            return;
        }

    }

    componentDidMount() {

        window?.addEventListener("storage", this.listenerStorage);

        const verificarAutenticacao = (url) => {
        
            const code = new URL(url).searchParams.get('code');
            const codeFake = new URL(url).searchParams.get('codeFake');
            const page = new URL(url).searchParams.get('page');
            const logoutGovbr = new URL(url).searchParams.get('logoutGovbr');
            if (code) {
                let clientId = configuration.clientId;
                let redirectURL;
                if (platform.isCordova) {
                    redirectURL = encodeURIComponent('meuinss://autorizar.html' + (page ? `?page=${page}` : ''));
                } else {
                    redirectURL = encodeURIComponent(configuration.baseUrl + (page ? `?page=${page}` : ''));
                }
    
                document.getElementById('modalWindowOpen').style.display = 'block';

                this.setState({loadingToken: true});

                getSeguroPromise(`govbrservices/token/${code}/clientid/${clientId}?redirectURL=${redirectURL}`)
                    .then(resp => {
                        return resp.data;
                    })
                    .then(tokens => {
                        if (tokens.erro) {
                            alert(`Não foi possível concluir a autenticação.  ` + tokens.erro);
                        } else if (!tokens.access_token || tokens.access_token === "undefined" || tokens.access_token === "null") {
                            alert(`Não foi possível concluir a autenticação, tente novamente mais tarde. [1]`);
                        } else {
                            try {
                                let time = new Date();
                                time.setSeconds(tokens.expires_in);
                                localStorage.setItem('ifs_auth', tokens.access_token);
                                localStorage.setItem('ifs_ts', time);
                                window.location.replace(configuration.baseUrl + '#' + (page || '/'));
                                return;
                            } catch (error) {
                                alert(`Não foi possível definir informações de autenticação [2]. ` + JSON.stringify(tokens));
                            }
                        }
                        window.location.href = configuration.baseUrl + '#/login';
                    })
                    .catch(() => {
                        alert(`Não foi possível concluir a autenticação, tente novamente mais tarde. [3]`);
                        window.location.href = configuration.baseUrl + '#/login';
                    }).finally(() => {
                        setTimeout(() => {
                           this.setState({loadingToken: false});
                        }, 500);
                    })
            } else if (codeFake) {
                const expiresIn = new URL(url).searchParams.get('expires_in');
                localStorage.setItem('ifs_auth', codeFake);
                localStorage.setItem('ifs_ts', expiresIn);
                window.location.replace(configuration.baseUrl + '#' + (page || '/'));
            } else if (logoutGovbr === 'true') {
                this.props.deslogarUsuario();
            }
    
        };

        window.addEventListener("onSchemeURLCall", (event) => {
            closeBrowserTab();
            if (event.detail.indexOf('kba.html') !== -1) {
                this.props.deslogarUsuario();
            } else if (event.detail.indexOf('?') !== -1) {
                verificarAutenticacao(event.detail);
            } else {
                window.location.href = configuration.baseUrl + "#/login";
            }
        });

        verificarAutenticacao(window.location.href);

        if (platform.isCordova) {

            //onboardScreen
            let onBoardScreenShowed = localStorage.getItem('onBoardScreenShowed');
            if (!onBoardScreenShowed) {
                history.push('/bem-vindo')
                //return;
            }
            document.addEventListener("deviceready", onDeviceReady, false);
            document.addEventListener("deviceready", () => {
                
                let callback = (payload, type) => {

                    let showForegroundParams = {};
                    if (payload.gcm) {
                        showForegroundParams.title = payload.gcm.title;
                        showForegroundParams.body = payload.gcm.body;
                    } else if (payload.aps && payload.aps.alert) {
                        showForegroundParams.title = payload.aps.alert.title;
                        showForegroundParams.body = payload.aps.alert.body;
                    }

                    let action = {}
                    try {
                        action = JSON.parse(payload.action);
                    } catch {
                        action = null;
                    }

                    if (showForegroundParams.body) {
                        showForegroundNotification(showForegroundParams.title, showForegroundParams.body, action);
                    }

                }

                registerOnMessage(callback);                
            }, false);
        }
    }

    componentWillUnmount() {
        window?.removeEventListener("storage", this.listenerStorage);
    }

    listenerStorage(event) {
        if (event.key === "ifs_auth") {
            if (event.newValue === null) {
                console.debug("ifs_auth removido do localStorage!");
                this.setState({ ...this.state, reloadWindow: true });
                return;
            }
            if(event.oldValue !== event.newValue){
                console.debug("NOVO LOGIN DETECTADO")
                this.setState({ ...this.state, reloadWindow: true });
                return;
            }
        }
    }

    render() {
        const { atualizacao } = this.props;
        const { loadingToken } = this.state;

        if(loadingToken) {
            return <></>
        }

        return (
            <div className='fullScreen'>
                <div id="meuinss-foreground-notification"></div>
                <div id="meuinss-message"></div>

                {atualizacao === 2 /* ATUALIZACAO OPCIONAL */ && !sessionStorage.getItem('atualizacaoInformada') && (
                    <div className="solicitar-atualizacao-overlay">
                        <SolicitarAtualizacao tipo={2} />
                    </div>
                )}

                {atualizacao === 3 /* ATUALIZACAO FORCADA */ && (
                    <div className="solicitar-atualizacao-overlay">
                        <SolicitarAtualizacao tipo={3} />
                    </div>
                )}

                {platform.isCordova && <DrawerPDF />}

                <Switch>
                    <Route path='/login' component={Login} />
                    <Route exact path='/carteira/digital' component={CarteiraDigital} />
                    <Redirect from='/autenticidade' to='/aberto/autenticidade' />
                    <Redirect from='/servico-manutencao' to='/aberto/servico-manutencao' />
                    <Redirect from='/politica' to='/aberto/politica' />
                    <Redirect from='/manutencao' to='/aberto/manutencao' />
                    <Redirect from='/emissao-certidao-contribuicao' to='/certidao-contribuicao' />
                    <Route path='/bem-vindo' component={SwipableOnboardScreen} />
                    <Route breadcrumbProps={{skip: true}} path='/' component={ProtectedAppWrapper} />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    atualizacao: state.session.atualizacao
})

const mapDispatchToProps = dispatch => bindActionCreators({ atualizarSituacaoVersao, confirmarLogin, deslogarUsuario, verificarParametrosFirebase }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(App)
